export type CookiePreferences = {
  essential: true;
  analytics: boolean;
  personalization: boolean;
  marketing: boolean;
  updatedAt: string;
};

const COOKIE_PREFS_KEY = 'lewouhmart_cookie_preferences_v1';

export function getDefaultCookiePreferences(): CookiePreferences {
  return {
    essential: true,
    analytics: false,
    personalization: false,
    marketing: false,
    updatedAt: new Date().toISOString(),
  };
}

export function readCookiePreferences(): CookiePreferences | null {
  try {
    const raw = window.localStorage.getItem(COOKIE_PREFS_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<CookiePreferences>;
    return {
      essential: true,
      analytics: Boolean(parsed.analytics),
      personalization: Boolean(parsed.personalization),
      marketing: Boolean(parsed.marketing),
      updatedAt: typeof parsed.updatedAt === 'string' ? parsed.updatedAt : new Date().toISOString(),
    };
  } catch {
    return null;
  }
}

export function saveCookiePreferences(next: Omit<CookiePreferences, 'updatedAt' | 'essential'> & { essential?: true }) {
  const value: CookiePreferences = {
    essential: true,
    analytics: Boolean(next.analytics),
    personalization: Boolean(next.personalization),
    marketing: Boolean(next.marketing),
    updatedAt: new Date().toISOString(),
  };
  window.localStorage.setItem(COOKIE_PREFS_KEY, JSON.stringify(value));
  window.dispatchEvent(new CustomEvent('lewouhmart:cookie-preferences-updated', { detail: value }));
  return value;
}

export function acceptAllCookies() {
  return saveCookiePreferences({ analytics: true, personalization: true, marketing: true });
}

export function rejectNonEssentialCookies() {
  return saveCookiePreferences({ analytics: false, personalization: false, marketing: false });
}

